import { render } from "./GestioneUtenti.vue?vue&type=template&id=106a83b1"
import script from "./GestioneUtenti.vue?vue&type=script&lang=js"
export * from "./GestioneUtenti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__